var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 13.7499H50.4166M22.9166 25.2083V36.6666M32.0833 25.2083V36.6666M9.16658 13.7499H45.8332L42.2124 46.3374C42.0883 47.4589 41.5549 48.4952 40.7142 49.2479C39.8736 50.0005 38.7849 50.4167 37.6566 50.4166H17.3433C16.2149 50.4167 15.1262 50.0005 14.2856 49.2479C13.445 48.4952 12.9115 47.4589 12.7874 46.3374L9.16658 13.7499ZM16.8322 7.21179C17.2029 6.42568 17.7895 5.76116 18.5235 5.29576C19.2575 4.83035 20.1087 4.58324 20.9778 4.58325H34.022C34.8915 4.58281 35.7432 4.82971 36.4777 5.29514C37.2122 5.76057 37.7991 6.42533 38.1699 7.21179L41.2499 13.7499H13.7499L16.8322 7.21179V7.21179Z",
    stroke: "url(#paint0_linear_24_251)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_251",
    x1: 42.8999,
    y1: 8.06659,
    x2: 16.8666,
    y2: 50.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3EBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.d96ddcae6b7d03d275de83b5c5d328e8.svg";
export { ForwardRef as ReactComponent };